const config = {
  app: {
    isProd: import.meta.env.VITE_IS_PROD || false
  },
  parse: {
    appId: import.meta.env.VITE_PARSE_APP_ID || '',
    // appKey: process.env.VITE_PARSE_APP_KEY || '',
    serverURL: import.meta.env.VITE_PARSE_SERVER_URL || ''
  },
  strapi: {
    url: import.meta.env.VITE_STRAPI_URL || '',
    bearerToken: import.meta.env.VITE_STRAPI_BEARER_TOKEN || ''
  },
  mixpanel: {
    projectToken: import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN || ''
  }
}

export default config
